import type { DialogProps } from '@material-ui/core'
import type { ReactElement } from 'react'

import { Dialog } from '@material-ui/core'
import { H1 } from '@monthio/design-system'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { EskatLogoImage } from './EskatLogoImage'

type EskatSuccessModalProps = Omit<DialogProps, 'children'>

const DialogBodyStyled = styled.div`
	text-align: center;
	background-color: white;
	padding: 20px 20px 10px;
	max-width: 400px;
`

export const EskatSuccessModal = (
	props: EskatSuccessModalProps,
): ReactElement => {
	const { t } = useTranslation()

	return (
		<Dialog {...props}>
			<DialogBodyStyled>
				<EskatLogoImage />
				<H1>
					{t('eskat-consent-success-message')}
					<br />
					{t('eskat-consent-welcome-back')}
				</H1>
			</DialogBodyStyled>
		</Dialog>
	)
}
